import { render, staticRenderFns } from "./Ifrs_16.vue?vue&type=template&id=b73258f4&"
import script from "./Ifrs_16.vue?vue&type=script&lang=js&"
export * from "./Ifrs_16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports